/* eslint-disable max-classes-per-file */
import { ImageHeight, WidgetType } from '@wayout-fe/util';

export class BaseItem {
	imageUrl = '';
	imageAlt = '';
	actionUrl = '';

	constructor(imageUrl: string, imageAlt: string, actionUrl: string) {
		this.imageUrl = imageUrl;
		this.imageAlt = imageAlt;
		this.actionUrl = actionUrl;
	}

	static createEmpty() {
		return new BaseItem('', '', '');
	}
}

export interface BaseWidget {
	widgetType: string;
	visible: boolean;
	pageType: 'tour' | 'hotel';
	title: string;
	subtitle: string;
	anchor?: string;
	widgetId?: string;
}

// Specific widget types
export interface BannerWidget extends BaseWidget {
	widgetType: WidgetType.Banner;
	items: BaseItem[];
}

export interface CenteredCarouselWidget extends BaseWidget {
	widgetType: WidgetType.CenteredCarousel;
	items: BaseItem[];
}

export interface ClassicCarouselWidget extends BaseWidget {
	widgetType: WidgetType.ClassicCarousel;
	items: BaseItem[];
}

export interface SevenImagePanelWidget extends BaseWidget {
	widgetType: WidgetType.SevenImagePanel;
	items: BaseItem[];
}

export class TokenItem {
	title: string;
	actionUrl: string;

	constructor(title: string, actionUrl: string) {
		this.title = title;
		this.actionUrl = actionUrl;
	}

	static createEmpty() {
		return new TokenItem('', '');
	}
}

export interface TokensWidget extends BaseWidget {
	widgetType: WidgetType.Tokens;
	backgroundColor?: string;
	tokens: TokenItem[];
}

export interface ImageGridWidget extends BaseWidget {
	widgetType: WidgetType.ImageGrid;
	items: BaseItem[];
}

export interface SingleImageWidget extends BaseWidget {
	widgetType: WidgetType.SingleImage;
	imageHeight: ImageHeight;
	items: BaseItem[];
}

// Union type for all possible widgets
export type Widget =
	| BannerWidget
	| CenteredCarouselWidget
	| ClassicCarouselWidget
	| SevenImagePanelWidget
	| TokensWidget
	| ImageGridWidget
	| SingleImageWidget;

// Root configuration type
export interface HomeConfiguration {
	widgets: Widget[];
}
